import React from 'react';
const IconActionSendFill = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M23.6302 12L0.970215 1.27002L2.43021 9.58002L9.00021 12.67V14.88L2.86021 11.99V12L0.970215 22.73L23.6302 12Z" fill="#2D2E2E"/>
</svg>
);
};
export default IconActionSendFill;